// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
import routes from 'js/core_pre_webpack/routes';

(function () {
  var CREATED = 'CREATED';
  var UNDOING = 'UNDOING';
  var UNDONE = 'UNDONE';

  Components.Toasts.AutoBookmarkToast = createReactClass({
    propTypes: {
      undoBookmark: PropTypes.func.isRequired,
      linkSettingsOnUndo: PropTypes.bool,
    },

    getInitialState: function () {
      return {
        bookmarkState: CREATED,
      };
    },

    undoBookmark: function () {
      this.setState({
        bookmarkState: UNDOING,
      });

      this.props.undoBookmark(
        function () {
          this.setState({
            bookmarkState: UNDONE,
          });
        }.bind(this),
      );
    },

    renderText: function () {
      if (
        this.state.bookmarkState === CREATED ||
        this.state.bookmarkState === UNDOING
      ) {
        return (
          <span>
            <a
              href={routes.bookmarks_url()}
              style={{ color: 'inherit' }}
              className="u-textDecorationUnderline"
            >
              Bookmarked
            </a>
          </span>
        );
      } else if (this.state.bookmarkState === UNDONE) {
        return <span>Bookmark removed</span>;
      }
    },

    renderAction: function () {
      if (this.state.bookmarkState === CREATED) {
        return (
          <span
            onClick={this.undoBookmark}
            className="u-clickable u-textDecorationUnderline"
          >
            Undo
          </span>
        );
      } else if (this.state.bookmarkState === UNDOING) {
        return <span>Undoing...</span>;
      } else if (this.state.bookmarkState === UNDONE) {
        if (this.props.linkSettingsOnUndo) {
          return (
            <a
              href="/settings#privacy-settings"
              onClick={function () {
                window.location = '/settings#privacy-settings';
              }}
              style={{ color: 'inherit' }}
            >
              Privacy Settings
            </a>
          );
        }
      }
    },

    render: function () {
      return (
        <div className="u-fs14 u-tcWhite u-fw700 u-taCenter">
          <i className="fa fa-bookmark u-tcWhite u-mr2x" />
          <span className="u-mr2x">{this.renderText()}</span>
          <span className="u-floatRight u-tcWhite">{this.renderAction()}</span>
        </div>
      );
    },
  });
})();
